import React from "react";
import Context from "../../../../../Context";
import Blocker from "../../../../Misc/Blocker";

export default class UserDeatilIP extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      pending: false,
      allow: [],
      deny: [],
    };
  }

  componentDidMount() {
    this.load();
  }

  load = async () => {
    if (!this.props.user["id"]) return;
    this.setState({ pending: true });

    let allow = [];
    let result = await this.context.api.q("/admin/user/iptable/get", {
      id: this.props.user["id"],
      type: "A",
    });
    if (result !== false) {
      allow = result["iptable"] ? result["iptable"].split(", ") : [];
    }

    let deny = [];
    result = await this.context.api.q("/admin/user/iptable/get", {
      id: this.props.user["id"],
      type: "D",
    });
    if (result !== false) {
      deny = result["iptable"] ? result["iptable"].split(", ") : [];
    }

    this.setState({ allow, deny, pending: false });
  };

  remove = (type, ip) => {
    let arr = this.state[type];
    let index = arr.indexOf(ip);
    if (index > -1) {
      arr.splice(index, 1);
      this.setState({ [type]: arr });
    }
  };

  add = (type) => {
    this.context.prompt("Введите IP адрес").then((result) => {
      if (result.value) {
        let arr = this.state[type];
        arr.push(result.value);
        this.setState({ [type]: arr });
      }
    });
  };

  check = async (id, checked) => {
    if (!this.props.user["id"]) return;
  };

  save = async (data) => {
    let id = this.props.user["id"];
    if (!id) return;

    this.props.onPending(true);

    let result = await this.context.api.q("/admin/user/iptable/set", {
      id,
      type: "A",
      iptable: this.state.allow.join(","),
    });
    if (result !== false) {
      this.context.toast("Таблица разрешенных адресов сохранена", "success");
    } else {
      this.context.toast(
        "Не удалось сохранить таблицу разрешенных адресов",
        "error"
      );
    }

    result = await this.context.api.q("/admin/user/iptable/set", {
      id,
      type: "D",
      iptable: this.state.deny.join(","),
    });
    if (result !== false) {
      this.context.toast("Таблица запрещенных адресов сохранена", "success");
      this.props.onFinish();
    } else {
      this.context.toast(
        "Не удалось сохранить таблицу запрещенных адресов",
        "error"
      );
      this.props.onPending(false);
    }
  };

  render() {
    return (
      <>
        <div>
          <Blocker on={this.state.pending}>
            <div className="row text-dark-50">
              <div className="col-lg-6">
                <div className="font-weight-bolder text-dark-75  mb-5">
                  Разрешенные адреса
                  <span
                    onClick={() => this.add("allow")}
                    className="flaticon2-add-1 icon-sm d-inline-block align-center text-hover-primary ml-3 cursor-pointer"
                  ></span>
                </div>
                {this.state.allow.map((ip) => (
                  <div key={ip}>
                    {ip}
                    <span
                      onClick={() => this.remove("allow", ip)}
                      className="flaticon2-cross icon-sm d-inline-block align-center text-hover-danger ml-3 cursor-pointer"
                    ></span>
                  </div>
                ))}
              </div>
              <div className="col-lg-6">
                <div className="font-weight-bolder text-dark-75  mb-5">
                  Запрещенные адреса
                  <span
                    onClick={() => this.add("deny")}
                    className="flaticon2-add-1 icon-sm d-inline-block align-center text-hover-primary ml-3 cursor-pointer"
                  ></span>
                </div>
                {this.state.deny.map((ip) => (
                  <div key={ip}>
                    {ip}
                    <span
                      onClick={() => this.remove("deny", ip)}
                      className="flaticon2-cross icon-sm d-inline-block align-center text-hover-danger ml-3 cursor-pointer"
                    ></span>
                  </div>
                ))}
              </div>
            </div>
            <div className="mt-15 ">
              <button className="btn btn-primary mr-2" onClick={this.save}>
                Сохранить
              </button>
              <button className="btn btn-light mr-2" onClick={this.cancell}>
                Отмена
              </button>
            </div>
          </Blocker>
        </div>
      </>
    );
  }
}
